import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "/data-share/git/metowolf/ipdb-old/src/index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(srcExports);